module.exports = __webpack_public_path__ + "static/img/juan.7ae0a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/juan.jpg
// module id = GKqz
// module chunks = 1